<template>
  <v-container class="settings">

    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <div class="overline ">
          <router-link class="primary--text" to="/home">home</router-link> >
          settings
        </div>
        <h1 class="primary--text my-6">
          <strong>Settings</strong>
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" offset-md="1">
        <h3>Ceol Settings</h3>
        <!-- {{ userProfile.user_settings }} -->
        
        <v-form @submit.prevent="updateUserProfile" v-if="userProfile.user_settings">
          <v-switch v-model="userProfile.user_settings.help_text"
            label="Show help in Ceol's interface"
            inset
            hint="Enable or disable help bubbles across Ceol."
            persistent-hint
            @change="updateUserProfile"
          ></v-switch>
          <v-switch
            v-model="userProfile.user_settings.dark_mode"
            hint="Make Ceol appear in a dark or light color palette."
            inset
            label="Enable dark theme"
            persistent-hint
            @change="updateUserProfile"
          ></v-switch>
          <v-switch
            value="false"
            hint="Coming soon ;)"
            inset
            disabled
            label="Save Recordings on your device"
            persistent-hint
            @change="updateUserProfile"
          ></v-switch>
        </v-form>
      </v-col>
      <v-col cols="12" md="4">
        <h3>User Settings</h3>
        <v-text-field 
          v-model="user.username"
          disabled
          persistent-hint
          hint="You cannot change username at this time."
          label="Username">
        </v-text-field>
        <v-textarea
          counter
          :rules="rules"
          label="User description (optional)"
          value=""
        ></v-textarea>
      </v-col>
    </v-row>
    <tune-detector></tune-detector>
    <cached-files></cached-files>
    <!-- <p>
      <strong>Token:</strong>
      {{currentUser.access.substring(0, 20)}} ... {{currentUser.access.substr(currentUser.access.length - 20)}}
    </p>
    <p>
      <strong>Id:</strong>
      {{currentUser.id}}
    </p>
    <p>
      <strong>Email:</strong>
      {{currentUser.email}}
    </p>
    <strong>Authorities:</strong>
    <ul>
      <li v-for="(role,index) in currentUser.roles" :key="index">{{role}}</li>
    </ul> -->
  </v-container>
</template>

<script>
import CachedFiles from '@/components/CachedFiles.vue';
import TuneDetector from '@/components/TuneDetector.vue';

export default {
  name: 'TradProfile',
  components: {
    CachedFiles,
    TuneDetector
  },
  data() {
    return {
      rules: [v => v.length <= 255 || 'Max 255 characters'],
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user.user;
    },
    userProfile() {
      return this.$store.state.tune.userProfile;
    },
    dark_mode() {
      if (!this.userProfile.user_settings)
        return false;
      return this.userProfile.user_settings.dark_mode;
    }
  },
  methods: {
    updateUserProfile() {
      this.$store.dispatch('tune/updateUserProfile', {
        id: this.userProfile.id,
        data: { user_settings: this.userProfile.user_settings }
      });
    }
  },  
  mounted() {
    this.$store.dispatch('tune/getUserProfile');
  },
  watch: {
    dark_mode(val) {
      this.$vuetify.theme.dark = val;
    }
  }
};
</script>
